import { render, staticRenderFns } from "./CardValuation.vue?vue&type=template&id=c85ea3d8&scoped=true&"
import script from "./CardValuation.vue?vue&type=script&lang=ts&"
export * from "./CardValuation.vue?vue&type=script&lang=ts&"
import style0 from "./CardValuation.vue?vue&type=style&index=0&id=c85ea3d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85ea3d8",
  null
  
)

export default component.exports